import { render, staticRenderFns } from "./QualitaReport.vue?vue&type=template&id=af10e04c&"
import script from "./QualitaReport.vue?vue&type=script&lang=js&"
export * from "./QualitaReport.vue?vue&type=script&lang=js&"
import style0 from "./QualitaReport.vue?vue&type=style&index=0&id=af10e04c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn,QBanner,QTable});qInstall(component, 'directives', {ClosePopup});
